import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  packageOption: {
    id: 'v8Xfo3',
    defaultMessage: 'Parcel',
    description: 'Segmented control option for standard parcel shipment type',
  },
  freightOption: {
    id: 'UxDYvQ',
    defaultMessage: 'Freight',
    description: 'Segmented control option for freight shipment type',
  },
  updateFailed: {
    id: 'zlYHpg',
    defaultMessage: 'Failed to update shipment type. Please try again.',
    description: 'Error notification when changing the shipment type (freight/package) fails',
  },
});
